import { useGlobalConstructionTypes } from 'pages/Catalogs/Common/CreateOrEditOtherVariable/hooks/useGlobalConstructionTypes';
import { ConstructionTypeCodeEnum } from 'types/constructionTypeCode';

import { useMemo } from 'react';

import { allConstructionTypes, type IConstructionTypeListItem } from '../utils';

export const useConstructionTypesListItems = () => {
    const { constructionTypes, fetchingStatus } = useGlobalConstructionTypes();

    const constructionTypesListItems = useMemo<IConstructionTypeListItem[]>(
        () =>
            (constructionTypes ?? [])
                .filter((item) => item.code !== ConstructionTypeCodeEnum.Unset)
                .map((item) => ({
                    id: item.id,
                    label: item.name,
                    code: item.code,
                }))
                .sort((a, b) => a.label.localeCompare(b.label, 'ru')),
        [constructionTypes],
    );

    const getConstructionTypeName = useMemo(() => {
        const nameById = new Map((constructionTypes ?? []).map((item) => [item.id, item.name]));

        return (id?: number, fallbackName?: string) => {
            if (!id) {
                return fallbackName || '';
            }

            return nameById.get(id) || fallbackName || allConstructionTypes[id] || '';
        };
    }, [constructionTypes]);

    return {
        constructionTypesListItems,
        getConstructionTypeName,
        fetchingStatus,
    };
};
